var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resultSet)?_c('v-data-table',{staticClass:"elevation-1",attrs:{"dense":"","headers":_vm.headers,"items":_vm.items,"items-per-page":_vm.maxRows ? _vm.maxRows + 1 : 10,"hide-default-footer":true}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }